/*
 * metaltex-markdown
 * Web component que converte Markdown (colado pelo admin) em HTML usando a lib marked.
 * Suporta a sintaxe completa de Markdown/GFM, incluindo HTML inline e tabelas.
 * Links externos (http/https) abrem em nova aba.
 */
(function () {
  if (customElements.get('markdown-content')) return;

  class MarkdownContent extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('script[type="text/template"]');
      const output = this.querySelector('[data-markdown-output]');
      if (!source || !output) return;

      const raw = source.textContent || '';

      if (typeof window.marked === 'undefined') {
        // Fallback: mostra o texto cru caso a lib não tenha carregado.
        output.textContent = raw;
        return;
      }

      output.innerHTML = this.render(raw);
    }

    render(raw) {
      const lib = window.marked;
      const renderer = new lib.Renderer();
      const baseLink = renderer.link.bind(renderer);

      // Abre links externos em nova aba.
      renderer.link = function (href, title, text) {
        let html = baseLink(href, title, text);
        const url = href && typeof href === 'object' ? href.href : href;
        if (typeof url === 'string' && /^https?:\/\//i.test(url)) {
          html = html.replace(
            /^<a /,
            '<a target="_blank" rel="noopener noreferrer" '
          );
        }
        return html;
      };

      const instance = new lib.Marked({
        renderer: renderer,
        breaks: true,
        gfm: true,
      });

      return instance.parse(raw);
    }
  }

  customElements.define('markdown-content', MarkdownContent);
})();
